import { render, staticRenderFns } from "./publicHome.vue?vue&type=template&id=2e7a5463&scoped=true&"
import script from "./publicHome.vue?vue&type=script&lang=js&"
export * from "./publicHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7a5463",
  null
  
)

export default component.exports